import { approveCustomerApiCall, checkForPendingCustomersApiCall, getPendingCustomersApiCall } from '@guryou/api-client-gql';

import { execute } from '../actions/actionWrapper';
import { Action, basicReducer } from '../core';

export const GET_PENDING_CUSTOMERS = { entity: 'GET_PENDING_CUSTOMERS', action: Action.GET_MANY };
export const CHECK_PENDING_CUSTOMERS = { entity: 'CHECK_PENDING_CUSTOMERS', action: Action.GET_ONE };
export const APPROVE_CUSTOMER = { entity: 'APPROVE_CUSTOMER', action: Action.HANDLE };

export const getPendingCustomers = () => async dispatch => execute(dispatch, () => getPendingCustomersApiCall(), GET_PENDING_CUSTOMERS, false, true);

export const checkForPendingCustomers = () => async dispatch =>
  execute(dispatch, () => checkForPendingCustomersApiCall(), CHECK_PENDING_CUSTOMERS, false, true);

export const approveCustomer = userId => async dispatch => execute(dispatch, () => approveCustomerApiCall({ userId: +userId }), APPROVE_CUSTOMER);

export const approvedCustomersReducers = {
  pendingCustomers: basicReducer(GET_PENDING_CUSTOMERS),
  checkPendingCustomers: basicReducer(CHECK_PENDING_CUSTOMERS),
  approveCustomer: basicReducer(APPROVE_CUSTOMER),
};
